import { YhPageHeader } from "@/erp_subpackage/components/YhPageHeader";
import React from "react";
import { useTranslation } from 'react-i18next';
import { useInternalModel } from "../internalModel";



export function PageHeader() {
    const { t } = useTranslation();
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useInternalModel();
    const internalStatusOption = [
        { label: t(`account.view.PageHeader.待申请`), value: 0 },
        { label: t(`account.view.PageHeader.待对方确认`), value: 1 },
        { label: t(`account.view.PageHeader.对方不认可`), value: 2 },
        { label: t(`account.view.PageHeader.待财务确认`), value: 3 },
        { label: t(`account.view.PageHeader.对方已驳回`), value: 4 },
        { label: t(`account.view.PageHeader.待财务审核`), value: 5 },
        { label: t(`account.view.PageHeader.财务已驳回`), value: 6 },
        { label: t(`account.view.PageHeader.待最终审核`), value: 7 },
        { label: t(`account.view.PageHeader.最终审核通过`), value: 8 },
        { label: t(`account.view.PageHeader.最终已驳回`), value: 9 },
    ]
    const searchFields = [
        {
            type: 'Input',
            placeholder: t(`account.view.PageHeader.对方单位`),
            fieldName: "adverseAccountName",
        },
        {
            type: 'Select',
            placeholder: t(`account.view.PageHeader.状态`),
            fieldName: "status",
            options: internalStatusOption
        },
    ]
    return (
        <>
            <YhPageHeader
                title= {t(`account.view.PageHeader.内部对账单`)}
                size="small"
                justify="end"
                searchValues={searchParam}
                searchFields={searchFields}
                onChange={updateSearchParam}
                triggerSearch
                handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
                handleReset={resetSearchParam}
            />
        </>
    );
}